import { applyMiddleware, createStore } from "redux";
import { routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";
import { connect } from "react-redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";

import createRootReducer, { IApplicationState } from "./Reducers";

export const history = createBrowserHistory();

export const store = configureStore();

export function withStore<
    TStoreState,
    TActionCreators,
    TComponent extends React.ComponentType<TStoreState & TActionCreators & any>
>(component: TComponent, stateSelector: (state: IApplicationState) => TStoreState, actionCreators: TActionCreators) {
    return connect(stateSelector, actionCreators)(component);
}

function configureStore() {
    const store = createStore(
        createRootReducer(history),
        composeWithDevTools(applyMiddleware(thunk, routerMiddleware(history)))
    );

    /* if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('./Reducers', () => {
            store.replaceReducer(createRootReducer(history));
        });
    }*/

    return store;
}
